// extracted by mini-css-extract-plugin
module.exports = {"topic":"Topic_topic__LntZN","topicItem":"Topic_topicItem__2D4u8","active":"Topic_active__gOxs2"};